/**
 * Constantes para o módulo de Notas Fiscais (Invoice)
 */

/**
 * Nomes das colunas de notas fiscais
 * Centralizadas para facilitar manutenção e evitar strings hardcoded
 */
export const TAX_NOTE_COLUMNS = {
  DATA_EMISSAO: "data_emissao",
  TIPO_MOVIMENTO: "tipo_movimento",
};
